export enum AUTH_PROVIDERS {
  OAUTH = "OAUTH",
  EVM = "EVM",
}
